module.exports={primary:"#346E9F",secondary:"#F5BB18"};